<template>
  <svg-icon type="mdi" :path="path"></svg-icon>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon'
import { mdiHomeSearchOutline } from '@mdi/js'

export default {
  name: 'IconHomeSearch',
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiHomeSearchOutline
    }
  }
}
</script>
